const UNSUPPORTED_TOKENS = ['YYYY', 'YY', 'DDDD', 'DD', 'D', 'A'];
const DELIMITERS_REGEX = /[^a-zA-Z]/g;

// This function is used to convert formats compatible with moment
// to unicode standard formats used by date-fns v2
// However, formats to convert were picked based on already used ones, so
// it's not an ideal solution since it removes some formats from being used
const convertFormatToDateFns = dateFormat => {
  const delimiters = dateFormat.match(DELIMITERS_REGEX);
  const tokens = dateFormat.split(DELIMITERS_REGEX);
  return tokens.map((token, i) => {
    const adjustedToken = UNSUPPORTED_TOKENS.includes(token) ? token.toLowerCase() : token;
    return `${adjustedToken}${delimiters[i] || ''}`;
  }).join('');
};

export { convertFormatToDateFns };
